import { render, staticRenderFns } from "./aLeecheros.vue?vue&type=template&id=64acc24a"
import script from "./aLeecheros.vue?vue&type=script&lang=js"
export * from "./aLeecheros.vue?vue&type=script&lang=js"
import style0 from "./aLeecheros.vue?vue&type=style&index=0&id=64acc24a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports